export default {
    addAction(context){
        context.commit('add',10)
    },
    reduceAction(context){
        setTimeout(()=>{context.commit('reduce')},3000);
        console.log('我比reduce提前执行');
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js